import axios from 'axios';
import md5 from "js-md5";
import qs from 'qs'
import Router from '../router'
import Global from '../config/global.js'
axios.defaults.timeout = 30000; //超时时间设置
axios.defaults.baseURL = Global.BASE_URL; //填写域名\
//http request 拦截器
axios.interceptors.request.use(
    config => {
        if (config.type == 'formData' || config.method != 'post') {
            return config
        }
        config.data = qs.stringify(config.data)
        return config
    }, (err) => {
        return Promise.reject(err);
    })

//响应拦截器即异常处理
axios.interceptors.response.use(response => {
    if (response.data.refreshToken != null) {
        localStorage.setItem('token', response.data.refreshToken)
        Router.replace('/home')
    }
    return response
}, err => {
    console.log("err")
    console.log(err)
    if (err && err.response) {
        switch (err.response.status) {
            case 400:
                console.log('错误请求')
                break;
            case 401:
                console.log('未授权，请重新登录')
                break;
            case 403:
                console.log('拒绝访问')
                break;
            case 404:
                console.log('请求错误,未找到该资源')
                break;
            case 405:
                console.log('请求方法未允许')
                break;
            case 408:
                console.log('请求超时')
                break;
            case 500:
                console.log('服务器端出错')
                break;
            case 501:
                console.log('网络未实现')
                break;
            case 502:
                console.log('网络错误')
                break;
            case 503:
                console.log('服务不可用')
                break;
            case 504:
                console.log('网络超时')
                break;
            case 505:
                console.log('http版本不支持该请求')
                break;
            default:
                console.log(`连接错误${err.response.status}`)
        }
    } else {
        console.log('连接到服务器失败')
    }
    return Promise.resolve(err.response)
})


export function connetSign(str){
    return md5(str)
}

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
    params.userId = localStorage.getItem('userId');
    params.token = localStorage.getItem('token');
    params.sign= 'YTJsdVoyUnZiVzVsZEE9PQ==';

    var paramsStr = '';
    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            if(params[key] == undefined){
                continue
            }
            paramsStr += key + '=' + params[key] + '&';
        }
    }
    paramsStr = paramsStr.slice(0, -1); // 去掉末尾的 '&'

    console.log(paramsStr);

    const sign = connetSign(paramsStr);
    console.log(paramsStr);
    console.log(sign);

    params.sign = sign;

    
    return new Promise((resolve, reject) => {
        axios.get(url, {
                params: params
            })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                console.log('get请求方法当中出现问题')
                reject(err)
            })
    })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
    data.userId = localStorage.getItem('userId');
    data.token = localStorage.getItem('token');
    data.sign= 'YTJsdVoyUnZiVzVsZEE9PQ==';

    var paramsStr = '';
    for (var key in data) {
        if (data.hasOwnProperty(key)) {
            if(data[key] == undefined){
                continue
            }
            paramsStr += key + '=' + data[key] + '&';
        }
    }
    paramsStr = paramsStr.slice(0, -1); // 去掉末尾的 '&'

    console.log(paramsStr);

    const sign = connetSign(paramsStr);
    console.log(paramsStr);
    console.log(sign);

    data.sign = sign;
    return new Promise((resolve, reject) => {
        axios.post(url, data)
            .then(response => {
                console.log(response)
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.patch(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.put(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}


export const server = {
    /** 
     * 名称：getHosQrcode
     * 参数：paramObj
     */
    getHosQrcode: function(paramObj) {
        return get('/v2/hospital/getHosQrcode', paramObj);
    },
    /**
     * 授权登录接口user/login
     * 参数:wxId type=1 returnUrl
     */
    login: function(params) {
        return get('/v1/user/login', params);
    },
    /**
     * 获取默认医院接口
     * GET /v1/user/getDefaultHosId
     */
    getDefaultHosId: function(params) {
        return get('/v1/user/getDefaultHosId', params);
    },
    /**
     * GET /v1/request/getLastRequest
     */
    getLastRequest: function(params) {
        return get('/v1/request/getLastRequest', params);
    },
    /**
     * 物流查询
     * GET /v1/logistics/logQuery
     */
    logQuery: function(params) {
        return get('/v1/logistics/logQuery', params);
    },
    /**
     * 获取开通医院列表
     * GET /v2/hospital/list
     */
    hosListRequest: function(params) {
        return get('/v2/hospital/list', params)
    },
    // /**
    //  * 获取开通医院名称
    //  * GET /v2/hospital/list
    //  */
    // getHosListRequest: function(params) {
    //     return get('/v2/hospital/list', params)
    // },
    /**
     * 获取患者申请列表
     * GET /v1/request/list
     */
    getRequestList: function(params) {
        return get('/v1/request/list', params)
    },
    /**
     * 获取患者申请详情
     * GET /v2/hospital/list
     */
    detailRequest: function(params) {
        return get('/v1/request/detail', params)
    },

    /**
     * 获取用户对应的医院列表
     * GET /v1/user/getUserRoles
     */
    getUserRoles: function() {
        return get('/v1/user/getUserRoles');
    },
    /**
     * 验证token接口
     * /v1/user/validateToken
     */
    validateToken: function(params) {
        return get('/v1/user/validateToken',params);
    },
    /**
     * 获取医院服务类型
     * GET /v2/hospital/getHbMrRecordType：
     * 参数:wxId,hosId,token
     */
    getHbMrRecordType(params) {
        return get('/v2/hospital/getHbMrRecordType', params);
    },
    /**
     * 获取医院相关院区
     * POST /v2/hospital/getHosDistrict
     */
    getHosDistrict(params) {
        return post('/v2/hospital/getHosDistrict', params);
    },
    /**
     * 获取医院相关院区
     * POST /v2/hospital/getHosDistrict
     */
    getRequestCancel(params) {
        return post('/v1/request/cancle', params);
    },
    /**
     * 获取推荐医院
     * GET /v2/hospital/recommend
     */
    getRecommend(params) {
        return get('v2/hospital/recommend', params)
    },
    /**
     * 获取快递公司 GET /v2/hospital/hosExpressList
     */
    getHosExpressList(params) {
        return get('v2/hospital/hosExpressList', params)
    },
    /**
     * 获取预约自提自提地址
     * GET /v2/hospital/getPickupPlace
     */
    getPickupPlace(params) {
        return get('v2/hospital/getPickupPlace', params)
    },
    /**
     * 获取医院二级业务对应公告
     * POST /v2/hospital/getHosLob
     */
    getHosLob(params) {
        return post('/v2/hospital/getHosLob', params)
    },
    getTypeAttrs(params) {
        return get('v2/hospital/getTypeAttrs', params)
    },
    getIdTypes(params) {
        return get('v2/hospital/idType', params)
    },
    /**
     * GET /v1/util/getVerifyCode
     */
    getVerifyCode(params) {
        return get('v1/util/getVerifyCode', params)
    },
    /**
     * GET /v2/hospital/set 获取医院套餐
     */
    getUserGetPrint(params) {
        return get('v2/hospital/set', params)
    },
    /**
     * GET /v2/hospital/printItem 获取自定义打印
     */
    getPrintItem(params) {
        return get('v2/hospital/printItem', params)
    },
    /**
     * 	POST /v1/request/create 用户发起申请
     */
    create(params) {
        return post('/v1/request/create', params)
    },
    /**
     * 	 POST /v1/user/questionFeeback
     */
    questionFeeback(params) {
        return post('/v1/user/questionFeeback', params)
    },
    /**
     * GET /v1/request/appletPay 获取支付统一下单
     */
    pay(params) {
        return get('/v1/request/appletPay', params)
    },
    /**
     * GET /v1/request/getTicket客户端获取支付Ticket
     */
    getTicket(params) {
        return get('/v1/request/getTicket', params)
    },
    /**
     * GET /v1/user/getDefaultAddr 获取用户默认邮寄地址
     */
    getDefaultAddr() {
        return get('/v1/user/getDefaultAddr')
    },
    /**
     * POST /v1/request/getMarkup 补录
     */
    getMakeUp(params) {
        return post('/v1/request/getMarkup', params)
    },
    /**
     * POST /v1/request/markup 补录
     */
    markup(params) {
        return post('/v1/request/markup', params)
    },
    /**
     * POST /v1/request/queryCancelRequest用户查询取消申请状态
     */
    queryCancelRequest(params) {
        return post('/v1/request/queryCancelRequest', params)
    },
    /**
     * POST /v1/request/updateHosOutTime更新住院时间
     * @params:requestId 申请编号;outHospitalDate出院时间 YYYY-MM-DD
     */
    updateHosOutTime(params) {
        return post('/v1/request/updateHosOutTime', params)
    },
    /**
     * GET /v1/user/hasOwnWx获取用户是否关注公众号
     */
    hasOwnWx(params) {
        return get('/v1/user/hasOwnWx', params)
    },
    /**
     * GET /v2/hospital/getHosMrRecords获取医院患者住院信息
     */
    getHosMrRecords(params) {
        return get('/v2/hospital/getHosMrRecords', params)
    },
    /**
     * GET /v1/request/recordList
     */
    getRecordList(params) {
        return get('/v1/request/recordList', params)
    },
    /**
     * GET /v2/hospital/getHosDepList 获取医院科室列表
     */
    getHosDepList(params) {
        return get('/v2/hospital/getHosDepList', params)
    },

    /**
     * GET /v1/customer/requester
     * 用户发起申请
     */
    postrequestAd(params) {
        return post('/v1/customer/register', params)
    },
    /**
     * GET /v1/customer/requester
     * 查看用户登记信息
     */
    getrequestAd(params) {
        return get('/v1/customer/info', params)
    },
    /**
     * GET /v1/customer/userBehaviorLog
     * 用户行为采集
     */
    getuserBehaviorlog(params) {
        return get('/v1/customer/userBehaviorLog', params)
    },
    /**
     * GET /v1/invoice/list/available
     * 可开票申请列表
     */
    getAvailable(params) {
        return get('/v1/invoice/list/available', params)
    },
    /**
     * POST /v1/invoice/apply
     * 可开票申请列表
     */
    getinvoiceApp(params) {
        return post('/v1/invoice/apply', params)
    },
    /**
     * GET /v1/invoice/list
     * 可开票申请列表
     */
    getinvoiceLi(params) {
        return get('/v1/invoice/list', params)
    },
    /**
     * GET /applyLog
     * 申请过程日志收集
     */
    getApplyLog(params) {
        return get('/applyLog', params)
    },
    /**
     * GET /getEasyCaptcha
     * 短信验证码图片
     */
     getvalidationImage(params) {
        return get('/v1/util/getEasyCaptcha', params)
    },
     /**
     * 
     * 获取APP使用规则
     */
      getUsageRules() {
        return get('v1/data/privacy/usageRules')
    },

    /**
     * 获取单个广告对象
     * @param {} params 
     * @returns 
     */
    getAdvertInfo(params) {
        return get("/v1/op/getAdvertInfo", params)
    },

    /**
     * 获取集合广告对象
     * @param {} params 
     * @returns 
     */
    getAdvertList(params) {
        return get("/v1/op/getAdvertList", params)
    }

    
}